import React,{useEffect,useState } from 'react';
import { GET_ALL_PAYER } from '../constant'; 
import axios from 'axios';
import PayerTable from '../components/tables/PayerTable';
import {currentDateFormat} from "../utils";
import { useDispatch, useSelector } from 'react-redux';
import { setLoading } from '../redux/loaderAction';
import Loader from '../components/loader/Loader';

function PayerList() {
     const [payerDetails,setPayerDetails] = useState([]);
        const dispatch = useDispatch();
      const loading = useSelector((state) => state.loader.loading);
        const [currentDate,setCurrentDate] = useState(new Date());
        useEffect(()=>{
            dispatch(setLoading(true));
              
              axios.get(GET_ALL_PAYER)
              .then(response => {
                dispatch(setLoading(false));
                 //console.log(response.data);
                 setPayerDetails(response.data);
               })
              .catch(error => {
                 console.error(error);
               });
      
          },[]);
  return (
    <><section>
    
    <div className='d-flex justify-content-between form-container'>
          <div>
            <h2 className="fs-5 font-weight-600">Payor List  </h2>
          </div>
          <div>
            <span >{currentDateFormat(currentDate)}</span>
          </div>
        </div>
</section>
<section>
        <div>
        <PayerTable tableData={payerDetails} />        
        </div>
       
</section>{loading && <Loader />}</>
  )
}

export default PayerList